<template>
  <div
    v-if="component_data.params.locale !=='en'"
    :id="component_data.id"
    class="custom06_wrapper font-responsive"
  >
    <div class="custom06_contents w-5/6 mobile:w-full mobile:flex-column mobile-sides mx-auto">
      <article class="custom06_caption w-1/3 mobile:w-full mx-auto">
        <header>
          <figure class="custom06_icon" v-html="component_data.params.icon"></figure>
          <h2 v-html="component_data.params.title"></h2>
        </header>
        <div class="custom06_texts">
          <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
        </div>
        <a
          class="button_link"
          :href="component_data.params.link"
          v-html="component_data.params.button_value"
        ></a>
      </article>
      <div class="custom06_visual w-1/2 mobile:w-full r-2/1">
        <img :src="component_data.params.img.src" :alt="component_data.params.img.alt" />
      </div>
    </div>
  </div>
</template>

<script>
import video from "@/components/videoBlock/video";

export default {
  props: ["component_data"],
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {});
  },
  components: {
    "video-block": video,
  },
};
</script>

<style lang="scss" >
.button_link {
  margin: 0 2em;
  display: flex;
  max-width: 50%;
  text-transform: uppercase;
  color: #e41429;
  padding: 1em 1.7em;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  letter-spacing: 0.05em;
  transition-duration: 0.3s;
  font-size: 1.4em;
  background-color: #fff;
  border: 1px solid #e41429;
  text-decoration: none;
  @media screen and (max-width: 992px) {
    width: 28%;
  }
  @media screen and (max-width: 600px) {
    width: 60%;
  }
}
.button_link:hover {
  text-transform: uppercase;
  color: #fff;
  text-decoration: none;
  background: #e41429;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#e41429),
    to(#ae0b11)
  );
  background: linear-gradient(to right, #e41429 0%, #ae0b11 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e41429', endColorstr='#ae0b11', GradientType=1);
}
.custom06_wrapper {
  overflow: hidden;
  position: relative;
  margin: 60px 0;
}

.custom06_wrapper::before {
  content: "";
  height: 100%;
  width: 74.33%;
  position: absolute;
  background-color: #faf9f7;

  @media screen and (max-width: 992px) {
    width: 100%;
  }
}
.custom06_contents {
  position: relative;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.custom06_visual {
  position: relative;
  z-index: 0;
  margin: 4em 0;
}
.custom06_video img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.custom06_caption {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3em 0;

  @media screen and (max-width: 992px) {
    padding-left: 10%;
  }
}
.custom06_caption header {
  display: flex;
  align-items: center;
  margin-bottom: 4.5em;
}
.custom06_caption header h2 {
  color: #e41429;
  line-height: 1.41em;
  font-size: 3.8em;
  font-weight: 700;
  margin: 0 0 0 1.25em;
  padding-right: 0.625em;
  font-family: "Uni Neue", sans-serif;
}
.custom06_texts {
  padding: 0 3em;
  @media screen and (max-width: 992px) {
    padding-right: 5%;
  }
}
.custom06_caption p {
  font-size: 2em;
  line-height: 1.9em;
  font-family: "Lato", sans-serif;
}
.custom06_icon {
  margin: 0;
}
.custom06_icon svg {
  width: 10em;
  height: 10em;
  border-radius: 8px;
  color: white;
  background-color: #e41429;
  margin: 0;
}

.custom06_wrapper img {
  max-width: 100%;
}

.custom06_contents {
  flex-direction: row-reverse;
}
.custom06_visual > img {
  position: absolute;
  top: 0;
  left: 0;
  border-top-right-radius: 60px;
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.custom06_wrapper::before {
  border-bottom-right-radius: 60px;
  right: 8.333%;
}

.feat_video {
  bottom: -6em;
  display: flex;
  position: absolute;
  height: 10.2234vw;
  width: 16.5vw;
  left: -6em;
  bottom: -6em;
  z-index: 1;

  @media screen and (max-width: 992px) {
    bottom: -3em;
    height: 20vw;
    left: -3em;
    width: 30vw;
  }
}
.feat_video::before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #e41429;
  position: absolute;
  bottom: 3em;
  left: 3em;
  border-top-right-radius: 3em;

  @media screen and (max-width: 992px) {
    bottom: 1.5em;
    left: 1.5em;
  }
}
.feat_video img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-top-left-radius: 3em;
}
.feat_video .avc_thumb {
  border-top-left-radius: 3em;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 1920px) {
  .feat_video {
    width: 303px;
    height: 188px;
  }
}
</style>
